import React, { useEffect } from 'react'
import CollapseProvider, { useCollapse } from 'context/general/Collapse'
import EventForm from 'modules/events/form/EventForm'

export default function CreateEvent() {

    return (
        <CollapseProvider>
            <EventForm />
        </CollapseProvider>
    )
}
